import AppRoute from './AppRoute';

import DateStatistics from "./views/auctions/DateStatistics"
import Inventory from './views/logistics/Inventory'
import FileOverview from "./views/files/FileOverview";
import HomeView from "./views/Home";
import ProfileView from './views/Profile';
import UserManagement from './views/usermanagement/UserManagementRoute';
import authService from './services/AuthService';
import SalesRoutes from './views/sales/SalesRoutes';
import DailyOfferRoute from './views/daily-offer/DailyOfferRoute';
import MailBoxPage from './views/mailbox/MailBoxPage';
import InventoryByAccountAndLtSummary from './views/logistics/InventoryByAccountAndLtSummary';
import InventoryMovement from './views/logistics/InventoryMovement';
import {
  AdvanceDataCustomer, AdvanceDataNavPage,
  AdvanceDataSupplier
} from "./views/advanceData/AdvanceData";
import ArticleStatistics from "./views/auctions/ArticleStatistics";
import MailBoxManagement from "./views/mailbox/MailBoxManagement";
import FileManagement from "./views/files/FileManagement";
import {AnalyticsReport} from "./views/analytics/AnalyticsReport";
import LogisticsAvalanche from "./views/logistics-avalanche/LogisticsAvalanche";
import LogisticsAvalancheByAccountAndLtSummary
    from "./views/logistics-avalanche/LogisticsAvalancheByAccountAndLtSummary";
import LogisticsAvalancheByAccountAndLtRegion from "./views/logistics-avalanche/LogisticsAvalancheByAccountAndLtRegion";
import LogisticsAvalancheByAccountAndLtAndRegionSummary
    from "./views/logistics-avalanche/LogisticsAvalancheByAccountAndLtAndRegionSummary";
import TempdataServiceInstance from "./services/TempdataService";
import LogisticsAvalancheMovements from "./views/logistics-avalanche/movements/LogisticsAvalancheMovements";
import TourDataAvalanche from "./views/tourData-avalanche/TourDataAvalanche";
//import Kassenpartien from "./views/kassenpartien/Kassenpartien";

export const GUARD_ADMIN = () => {
  return authService.loggedIn && authService.principal && authService.principal.userRole === 'A';
};

export const GUARD_PREMIUM_OR_ADMIN_AND_SUPPLIER = () => {
    return GUARD_PREMIUM_OR_ADMIN() && GUARD_ISSUPPLIER()
};

export const GUARD_PREMIUM_OR_ADMIN = () => {
    return GUARD_ADMIN() || GUARD_PREMIUM();
};

export const GUARD_PREMIUM = () => {
    return authService.loggedIn && authService.principal &&  authService.principal.userRole === 'P';
};

export const GUARD_LOGGEDIN = () => {
  return authService.loggedIn;
};

export const GUARD_GUEST = () => {
  return !authService.loggedIn;
};

export const GUARD_FEATURESWITCH_ENABLED = (feature: string) => {
    return TempdataServiceInstance.featureSwitches[feature] === true;
}

const GUARD_HASACCOUNTROLE = (accountRole: string) => () => {
  if(!authService.loggedIn || !authService.principal) {
    return false;
  }
  if(authService.principal.userRole === 'A') {
    return true;
  }
  if(!authService.principal.accounts || !Array.isArray(authService.principal.accounts)) {
    return false;
  }
  const matchedAccounts = authService.principal.accounts.filter(acc => acc.roles && acc.roles.indexOf(accountRole) !== -1);
  return matchedAccounts.length > 0;
};

const GUARD_HASANYACCOUNT = () => {
  if(!authService.loggedIn || !authService.principal) {
    return false;
  }
  if (GUARD_LOGISTICSPLUS_OR_ADMIN()) {
      return true;
  }
  if(!authService.principal.accounts || !Array.isArray(authService.principal.accounts)) {
    return false;
  }
  return authService.principal.accounts.length > 0;
};

export const GUARD_ISCUSTOMER = ()=> GUARD_HASACCOUNTROLE('K')();
export const GUARD_ISSUPPLIER = ()=> GUARD_HASACCOUNTROLE('Z')();

export const GUARD_ISCUSTOMERORSUPPLIER = () => GUARD_ISCUSTOMER() || GUARD_ISSUPPLIER();

export const GUARD_STATISTICS = () => {
  if(!authService.loggedIn || !authService.principal) {
    return false;
  }
  if(authService.principal.userRole === 'A') {
    return true;
  }
  if(!authService.principal.privileges || !Array.isArray(authService.principal.privileges)) {
    return false;
  }
  return authService.principal.privileges.indexOf('1') !== -1 || authService.principal.privileges.indexOf('11') !== -1;
};

const GUARD_HASPRIVIILEGE = (privilege: string) => () => {
  if(!authService.loggedIn || !authService.principal) {
    return false;
  }
  if(authService.principal.userRole === 'A') {
    return true;
  }
  if(!authService.principal.privileges || !Array.isArray(authService.principal.privileges)) {
    return false;
  }
  return authService.principal.privileges.indexOf(privilege) !== -1;
};

const GUARD_INBOX = GUARD_HASPRIVIILEGE('inbox');
const GUARD_OFFERSVRM = GUARD_HASPRIVIILEGE('offer-vrm');
const GUARD_LOGISTICSPLUS = GUARD_HASPRIVIILEGE('logistics-plus');
const GUARD_USER_MANAGEMENT = GUARD_HASPRIVIILEGE('manage_users');

export const GUARD_LOGISTICSPLUS_OR_ADMIN =
    () => GUARD_ADMIN() || GUARD_LOGISTICSPLUS()

const GUARD_OFFERSGUEST = () => {
  return (!GUARD_OFFERSVRM() || GUARD_GUEST());
};

const routes: AppRoute[] = [
    {path: '/', component: HomeView, title: 'Home', icon: 'home', hideInNav: false, exact: true, subRoutes: []},
    {path: '/profile', component: ProfileView, title: 'Profile', icon: 'home', hideInNav: true, exact: true, subRoutes: []},

    {path: '/auctions/:articleID/:articleLength', component: ArticleStatistics,  title: 'AuctionDetails', icon: 'leaf', hideInNav: true, guard: GUARD_STATISTICS},
    {path: '/auctions/', component: DateStatistics, title: 'Auctions', icon: 'leaf', subRoutes: [], guard: GUARD_STATISTICS},

    {path: '/advanceData', exact: true,  component: AdvanceDataNavPage, title: 'AdvanceData', icon: 'sticky note', subRoutes: [
        {path: '/advanceData/supplier', component: AdvanceDataSupplier, title: 'SalesSupplier', icon: 'truck', heading: false,
          guard: GUARD_ISSUPPLIER},
        {path: '/advanceData/customer', component: AdvanceDataCustomer, title: 'SalesCustomer', icon: 'shopping cart', heading: false,
          guard: GUARD_ISCUSTOMER},
      ], guard: GUARD_ISCUSTOMERORSUPPLIER},

    // repeat because subroutes are not registered with main router but only used for navigation menu
    {path: '/advanceData/supplier', component: AdvanceDataSupplier, title: 'SalesSupplier', icon: 'truck', heading: false,
      guard:  GUARD_ISSUPPLIER, hideInNav: true},
    {path: '/advanceData/customer', component: AdvanceDataCustomer, title: 'SalesCustomer', icon: 'shopping cart', heading: false,
      guard: GUARD_ISCUSTOMER, hideInNav: true},
  {path: '/tourData-avalanche/', component: TourDataAvalanche, title: 'TourDataAvalanche', icon: 'truck', subRoutes: [], guard: () => GUARD_FEATURESWITCH_ENABLED("TourendatenAvalanche") || GUARD_ADMIN()},

    {path: '/offers', component: DailyOfferRoute, title: 'OffersGuest', icon: 'calendar alternate', subRoutes: [], guard: GUARD_OFFERSGUEST},
    {path: '/offers', component: DailyOfferRoute, title: 'Offers', icon: 'calendar alternate', subRoutes: [], guard: GUARD_OFFERSVRM}, // TODO also check in Backend

    {path: '/sales', component: SalesRoutes, title: 'Sales', icon: 'calculator', subRoutes: [
        {path: '/sales/supplier', component: SalesRoutes, title: 'SalesSupplier', icon: 'truck', heading: false, guard: GUARD_ISSUPPLIER},
        {path: '/sales/customer', component: SalesRoutes, title: 'SalesCustomer', icon: 'shopping cart', heading: false, guard: GUARD_ISCUSTOMER},
        {path: '/sales/supplier-article', component: SalesRoutes, title: 'SalesSupplierArticle', icon: 'truck', heading: false, guard: GUARD_PREMIUM_OR_ADMIN_AND_SUPPLIER},
      ], guard: GUARD_ISCUSTOMERORSUPPLIER},

    {path: '/logistics/inventory/:accountNumber/:ltNumber/:market', component: InventoryMovement, title: 'InventoryAccountType', icon: 'pallet', heading: false,
      guard: () => GUARD_FEATURESWITCH_ENABLED("Logistik") && GUARD_HASANYACCOUNT() , hideInNav: true},
    {path: '/logistics/inventory/:accountNumber/:ltNumber', component: InventoryByAccountAndLtSummary, title: 'InventoryAccountType', icon: 'pallet', heading: false,
      guard: () => GUARD_FEATURESWITCH_ENABLED("Logistik") && GUARD_HASANYACCOUNT(), hideInNav: true},
    {path: '/logistics/inventory/', component: Inventory, title: 'Inventory', icon: 'pallet', subRoutes: [
      ], guard: () => GUARD_FEATURESWITCH_ENABLED("Logistik") && GUARD_HASANYACCOUNT(), exact: true},

    {path: '/logistics/movement-avalanche/:accountNumber/:ltNumber/:market', component: LogisticsAvalancheMovements, title: 'InventoryAvalancheMovements', icon: 'pallet', heading: false, exact: true,
        guard: () => GUARD_FEATURESWITCH_ENABLED("LogistikAvalancheBewegungen") || GUARD_ADMIN(), hideInNav: true},
    {path: '/logistics/movement-avalanche/:accountNumber/:ltNumber/:region/:market', component: LogisticsAvalancheMovements, title: 'InventoryAvalancheMovements', icon: 'pallet', heading: false, exact: true,
        guard: () => GUARD_FEATURESWITCH_ENABLED("LogistikAvalancheBewegungen") || GUARD_ADMIN(), hideInNav: true},
    {path: '/logistics/inventory-avalanche-region/:accountNumber/:ltNumber/:region', component: LogisticsAvalancheByAccountAndLtAndRegionSummary, title: 'InventoryAvalancheAccountLTRegion', icon: 'pallet', heading: false,
        guard: () => GUARD_FEATURESWITCH_ENABLED("LogistikAvalanche") || GUARD_LOGISTICSPLUS_OR_ADMIN(), hideInNav: true},
    {path: '/logistics/inventory-avalanche-region/:accountNumber/:ltNumber', component: LogisticsAvalancheByAccountAndLtRegion, title: 'InventoryAvalancheAccountLTRegion', icon: 'pallet', heading: false,
        guard: () => GUARD_FEATURESWITCH_ENABLED("LogistikAvalanche") || GUARD_LOGISTICSPLUS_OR_ADMIN(), hideInNav: true},
    {path: '/logistics/inventory-avalanche/:accountNumber/:ltNumber', component: LogisticsAvalancheByAccountAndLtSummary, title: 'InventoryAvalancheAccountLT', icon: 'pallet', heading: false,
        guard: () => GUARD_FEATURESWITCH_ENABLED("LogistikAvalanche") || GUARD_LOGISTICSPLUS_OR_ADMIN(), hideInNav: true},
    {path: '/logistics/inventory-avalanche/', component: LogisticsAvalanche, title: 'InventoryAvalanche', icon: 'pallet', subRoutes: [
        ], guard: () => GUARD_FEATURESWITCH_ENABLED("LogistikAvalanche") || GUARD_LOGISTICSPLUS_OR_ADMIN(), exact: true},

    /*
    {path: '/kassenpartien/', component: Kassenpartien, title: 'Kassenpartien', icon: 'dollar', subRoutes: [
        ], guard: GUARD_ADMIN, exact: true},
    */

    {path: '/mailbox', component: MailBoxPage, title: 'MailBox', icon: 'inbox', subRoutes: [], guard: GUARD_INBOX},
    {path: '/mailbox_management', component: MailBoxManagement, title: 'MailBoxManagement', icon: 'inbox', subRoutes: [], guard: GUARD_ADMIN},

    {path: '/files/', component: FileOverview, title: 'Files', icon: 'cloud download' , guard: GUARD_ISSUPPLIER, subRoutes: [
            {path: 'http://verpackungsordnung.landgard.de/', component: undefined, title: 'PackagingOrdinance', icon: 'box', heading: true},
            {path: '/files/contracts/', component: FileOverview, title: 'Contracts', icon: 'handshake', heading: true},
            {path: '/files/deliveryContract/', component: FileOverview, title: 'DeliveryContract', icon: 'clipboard', heading: false},
            {path: '/files/deliveryRegulation/', component: FileOverview, title: 'DeliveryRegulation', icon: 'book', heading: false},
            {path: '/files/scaleOfCharges/', component: FileOverview, title: 'ScaleOfCharges', icon: 'euro sign', heading: false},
            {path: '/files/membership/', component: FileOverview, title: 'Membership', icon: 'certificate', heading: true},
            {path: '/files/statutes/', component: FileOverview, title: 'Statutes', icon: 'clipboard', heading: false},
            {path: '/files/declarationOfAccession/', component: FileOverview, title: 'DeclarationOfAccession', icon: 'user circle', heading: false},
            {path: '/files/logistics/', component: FileOverview, title: 'Logistics', icon: 'truck', heading: true},
            {path: '/files/rvPrices/', component: FileOverview, title: 'RVPrices', icon: 'euro sign', heading: false},
            {path: '/files/it/', component: FileOverview, title: 'IT', icon: 'coffee', heading: true},
            {path: '/files/systems/', component: FileOverview, title: 'Systems', icon: 'laptop', heading: false},
            {path: '/files/maintenance/', component: FileOverview, title: 'Maintenance', icon: 'wrench', heading: false},
            {path: '/files/qualityManagement/', component: FileOverview, title: 'QualityManagement', icon: 'chart bar outline', heading: true},
            {path: '/files/globalGap/', component: FileOverview, title: 'GlobalGAP', icon: 'chart bar outline', heading: false},
            {path: '/files/globalGap-generalRegulations/', component: FileOverview, title: 'GeneralRegulations', icon: 'chart bar outline', heading: false},
            {path: '/files/globalGap-FlowersOrnamentalPlants/', component: FileOverview, title: 'FlowersOrnamentalPlants', icon: 'chart bar outline', heading: false},
            {path: '/files/globalGap-FlowersOrnamentalPlants-Requirements/', component: FileOverview, title: 'Requirements', icon: 'chart bar outline', heading: false},
            {path: '/files/globalGap-FlowersOrnamentalPlants-SampleDocumentsBP/', component: FileOverview, title: 'SampleDocumentsBP', icon: 'chart bar outline', heading: false},
            {path: '/files/globalGap-GRASPV2/', component: FileOverview, title: 'GRASPV2', icon: 'chart bar outline', heading: false},
            {path: '/files/globalGap-FruitVegetablesHerbs/', component: FileOverview, title: 'FruitVegetablesHerbs', icon: 'chart bar outline', heading: false},
            {path: '/files/globalGap-FruitVegetablesHerbs-Requirements/', component: FileOverview, title: 'Requirements', icon: 'chart bar outline', heading: false},
            {path: '/files/globalGap-FruitVegetablesHerbs-SampleDocuments/', component: FileOverview, title: 'SampleDocuments', icon: 'chart bar outline', heading: false},
            {path: '/files/globalGap-FruitVegetablesHerbs-SampleDocuments-CBPlants/', component: FileOverview, title: 'CBPlants', icon: 'chart bar outline', heading: false},
            {path: '/files/globalGap-FruitVegetablesHerbs-SampleDocuments-FVFruitsVegetables/', component: FileOverview, title: 'FVFruitsVegetables', icon: 'chart bar outline', heading: false},
        ]
    },

    {path: '/fileManagement', component: FileManagement, title: 'FileManagement', icon: 'cloud download', subRoutes: [], guard: GUARD_ADMIN},

    {path: '/settings/users',
      component: UserManagement,
      title: 'UserManagement',
      icon: 'users',
      subRoutes: [],
      guard: GUARD_USER_MANAGEMENT
    },

    {path: '/analytics/reports', component: AnalyticsReport, title: 'AnalyticsReport', icon: 'chart line', subRoutes: [], guard: GUARD_ADMIN},
];

export default routes;
